import React from 'react';
import AddCircleOutlineIcon from '@material-ui/icons/AddCircleOutline';
import { injectIntl, IntlShape } from 'react-intl';

import messages from 'containers/LawyerLegalProceedingsPage/judgementAdd/CivilParty/messages';
import { translate } from 'containers/services/translate';
import { CIVIL_PARTY_FORM } from 'containers/LawyerLegalProceedingsPage/judgementAdd/CivilParty/constants';
import EmptyAddFormBloc from 'components/EmptyAddFormBloc';

export interface AddCivilPartyProps {
  intl: IntlShape;
  addCivilParty: Function;
  disabled?: boolean;
}

const AddCivilParty: React.FC<AddCivilPartyProps> = (props): JSX.Element => {
  const handleClick = (event: React.SyntheticEvent) => {
    props.addCivilParty(CIVIL_PARTY_FORM.IN_WRITING);
  };

  return (
    <EmptyAddFormBloc
      title={translate(messages.civilPartyEmptyStateSubTitle, props)}
      buttonBlocTitle={translate(messages.civilPartyEmptyStateButton, props)}
      icon={<AddCircleOutlineIcon className="icon" />}
      handleClick={handleClick}
      disabled={props.disabled}
    />
  );
};

AddCivilParty.defaultProps = {
  disabled: false,
};

export default injectIntl(AddCivilParty);
